import React, { useEffect, createElement } from 'react';
/**
 * Lightweight SEO helper for a plain-React (non-Next) single page app.
 * Injects title, meta, OpenGraph, Twitter and schema.org JSON-LD into <head>.
 */
export function SEO() {
  useEffect(() => {
    const OG_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/26867317-615b-4aee-bbe1-f8601b45d196.jpg';
    const URL = 'https://goldencare.ba/';
    const TITLE = 'Golden Care — Agencija za kućnu njegu i posredovanje njegovatelja | Tuzla';
    const DESC = 'Golden Care povezuje porodice sa profesionalnim njegovateljima i njegovateljicama pružajući sigurnu, kvalitetnu i pouzdanu njegu starijih i nemoćnih osoba u Tuzli i širom Evrope.';
    document.documentElement.lang = 'bs';
    document.title = TITLE;
    const meta: Record<string, string> = {
      description: DESC,
      keywords: 'kućna njega, njegovatelji, njegovateljice, njega starijih osoba, Tuzla, Bosna i Hercegovina, agencija za njegu, 24-satna njega',
      author: 'Golden Care',
      robots: 'index, follow',
      'theme-color': '#C8A548',
      'og:type': 'website',
      'og:site_name': 'Golden Care',
      'og:title': TITLE,
      'og:description': DESC,
      'og:url': URL,
      'og:image': OG_IMAGE,
      'og:locale': 'bs_BA',
      'twitter:card': 'summary_large_image',
      'twitter:title': TITLE,
      'twitter:description': DESC,
      'twitter:image': OG_IMAGE
    };
    const created: HTMLElement[] = [];
    Object.entries(meta).forEach(([key, content]) => {
      const isOG = key.startsWith('og:') || key.startsWith('twitter:');
      const attr = isOG ? 'property' : 'name';
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
        created.push(tag);
      }
      tag.setAttribute('content', content);
    });
    // Canonical
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
      created.push(canonical);
    }
    canonical.setAttribute('href', URL);
    // JSON-LD structured data
    const ld = {
      '@context': 'https://schema.org',
      '@type': 'HomeAndConstructionBusiness',
      name: 'Golden Care',
      description: DESC,
      image: OG_IMAGE,
      url: URL,
      telephone: '+387 61 000 000',
      priceRange: '€€',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Tuzla',
        addressCountry: 'BA'
      },
      areaServed: 'Europe',
      openingHours: 'Mo-Su 00:00-23:59',
      sameAs: ['https://www.facebook.com/goldencare', 'https://www.instagram.com/goldencare']
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(ld);
    document.head.appendChild(script);
    created.push(script);
    return () => {
      created.forEach(el => el.remove());
    };
  }, []);
  return null;
}